import { useContext } from "react";
import AuthContext from "../context/Auth.context";
export default () => useContext(AuthContext);
